<template>
  <div class="ShadeBox" @mousewheel="mousewheel">
    <div class="maskLayer"></div>
    <div class="betaToast intro-x">
      <div class="toastTitle">技术支持</div>

      <div class="formDataClass">
        <div class="formNameclass">
          <p class="p1">输入技术支持描述</p>
          <p class="p2">
            <el-input  v-model="desc" placeholder="输入技术支持描述" clearable>
            </el-input>
          </p>
        </div>
      </div>

      <div class="buttom-p">
        <span class="span1" @click="setCancel">取消</span>
        <span class="span2" @click="btnWechat">确认绑定</span>
      </div>
    </div>
  </div>
</template>


<script>
import request from "../utils/request";

import Cookies from "js-cookie";

export default {
	props: {
		infoData: Object,
	},
  data() {
    return {
      desc: "",
    };
  },
	mounted() {
		this.desc = this.infoData.technical_support_desc
	},
  methods: {
    // 提交
    btnWechat: function () {
      if (!this.desc) {
        this.$message.error("请输入技术支持描述");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      request({
        url: "/api/profile/save/technical_support_desc",
        method: "POST",
        data: {
          technical_support_desc: this.desc,
        },
      })
        .then((res) => {
          this.$message.success("修改成功");
          this.$emit("setCancel", "Tesc", this.desc); // 控制弹窗关闭
          loading.close();
        })
        .catch((err) => {
          loading.close();
          this.$emit("setCancel", "Tesc"); // 控制弹窗关闭
        });
    },

    // 取消
    setCancel: function () {
      this.$emit("setCancel", "Tesc"); // 控制弹窗关闭
    },

    //  遮罩层防滚动穿透
    mousewheel: function (e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.ShadeBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  .maskLayer {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #000000;
    opacity: 0.7;
    width: 100%;
    height: 100%;
  }
  .betaToast {
    width: 23vw;
    min-width: 21rem;
    height: 265px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 22px;
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99999;
    overflow: hidden;
    .toastTitle {
      border-bottom: 1px solid #f4f4f4;
      padding: 20px;
      font-size: 16px;
      color: #333333;
      box-sizing: border-box;
    }
  }
}

.formDataClass {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  .formNameclass {
    width: 100%;
    box-sizing: border-box;

    .p1 {
      height: 47px;
      line-height: 50px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.buttom-p {
  width: 100%;
  border-top: 1px solid #f4f4f4;
  margin-top: 30px;
  text-align: right;
  padding: 20px;
  box-sizing: border-box;

  span {
    display: inline-block;
    padding: 10px 25px;
    margin-left: 4px;
    vertical-align: middle;
    box-sizing: border-box;
    border-radius: 6px;
  }
  .span1 {
    border: 1px solid #e2e8f0;
  }

  .span2 {
    color: #fff;
    background: #1890ff;
  }

  .span2:active {
    background: #2d9aff;
  }

  .span1:active {
    background: #e9e9e9;
  }
}
</style>